var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81728 15.5603V15.5582L2.81727 5.47C2.81727 4.38188 3.69916 3.5 4.78727 3.5H18.8505C19.9381 3.50178 20.8186 4.38469 20.8173 5.47278V5.474L20.8173 15.5582L20.8173 15.5601C20.8194 16.6478 19.9398 17.5315 18.8518 17.5342H11.0533H10.649L10.3583 17.8152L6.81728 21.2379V18.5342V17.5342H5.81728H4.78728H4.78252C3.69469 17.5315 2.81502 16.6478 2.81728 15.5603Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.5044C14.9971 9.95249 15.4426 9.50297 15.9946 9.50001C16.5469 9.49706 16.997 9.94206 17 10.4939C17.0047 11.0447 16.5617 11.4951 16.0104 11.5C15.4529 11.5012 15.0028 11.0562 15 10.5044Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10.4905C11.0049 9.9386 11.4564 9.49535 12.0087 9.50004C12.5596 9.5049 13.0029 9.95389 13 10.5044C12.9923 11.0559 12.5433 11.4991 11.9913 11.5C11.439 11.4934 10.9952 11.0421 11 10.4905Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00002 10.507C6.9962 9.95462 7.44089 9.50385 7.99323 9.50002C8.54557 9.49637 8.99617 9.94088 9 10.493C9 10.5 9 10.507 9 10.5139C8.99426 11.0588 8.55183 11.4981 8.00697 11.5C7.45463 11.5036 7.00385 11.0591 7.00002 10.507Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.04bc02cff56eb3f3688da89dc0c16e8a.svg";
export { ForwardRef as ReactComponent };